import { getUser } from '@/utils/User';
import { useContext } from 'react';
import { DashboardContext } from '@/context/DashboardContext';

// default params to send to backend
export const defaultParams = (language = null, user = null) => {

    const params = {};

    if(language){
        params.language = language;
    }

    if(user && user?.company){
        params.companyuser = user?.company;
    }

    // check if impersonating
    const userOriginal = getUser(true);
    if(userOriginal && userOriginal?.id){
        params.useroriginal = userOriginal?.id;
    }

    params.urlfrom = window.location.href;

    return params;
}

// Hook that provides API request using DashboardContext
export const useApi = () => {
    
    const { apiUrl, token, language, user, handleLogin, sendMessage, t } = useContext(DashboardContext);

    const callApi = async (method, path, params = {}, data = null, options = {}) => {
        
        const defaults = defaultParams(language, user);
        
        const config = {
            headers: { Authorization: `Bearer ${token}`, ...options.headers },
            params: { ...defaults, ...params },
        };
        
        try {
            
            const response = await window.axios.request({
                url: `${apiUrl}${path}`,
                method,
                data,
                ...config,
            });
            
            const responseData = response?.data;
            
            if (responseData?.result) {
                if (options.successMessage && sendMessage) {
                    sendMessage(options.successMessage, 'success');
                }
                const getData = responseData?.data ? responseData?.data : {};
                return { success: true, data: getData };
            }
            
            if (responseData?.status && responseData.status === 401) {
                handleLogin && handleLogin();
            }
            else {
                if (options.showError !== false) {
                    const errorMessage = options.errorMessage || (t ? t('error') : 'Error');
                    sendMessage && sendMessage(errorMessage, 'error');
                }
            }
            return { success: false };
        }
        catch (error) {
        
            if (error?.status && error.status === 401) {
                handleLogin && handleLogin();
            } 
            else {
                if (options.showError !== false) {
                    const errorMessage = options.errorMessage || (t ? t('error') : 'Error');
                    sendMessage && sendMessage(errorMessage, 'error');
                }
            }
            
            return { success: false };
        }
    };
    
    return { callApi };
};

// Export default hook for backward compatibility (if needed)
export default useApi;